// extracted by mini-css-extract-plugin
export default {"menu":"SidebarNew_menu__1BFFc","link":"SidebarNew_link__H0Y1-"};